import ButtonStateService from "@core-ui/ContextServices/ButtonStateService/ButtonStateService";
import type { NodeType } from "@core-ui/ContextServices/ButtonStateService/hooks/types";
import styled from "@emotion/styled";
import t from "@ext/localization/locale/translate";
import getNoteButtonIconColor from "@ext/markdown/elements/note/edit/logic/getNoteButtonIconColor";
import { type NoteType, noteIcons } from "@ext/markdown/elements/note/render/component/Note";
import EditorService from "@ext/markdown/elementsUtils/ContextServices/EditorService";
import type { Editor } from "@tiptap/core";
import { Icon } from "@ui-kit/Icon";
import { ToolbarDropdownMenuItem } from "@ui-kit/Toolbar";
import { useCallback } from "react";

const StyledIcon = styled(Icon)<{ noteType?: NoteType }>`
	color: ${({ noteType }) => getNoteButtonIconColor(noteType)};
`;

interface NoteMenuButtonProps {
	editor: Editor;
	noteType?: Exclude<NoteType, "hotfixes">;
}

const NoteMenuButton = ({ editor, noteType }: NoteMenuButtonProps) => {
	const nodeValues = { action: "note" as NodeType, attrs: { type: noteType } };
	const { isActive, disabled } = ButtonStateService.useCurrentAction(nodeValues);

	const onSelectNote = useCallback(() => {
		editor.chain().focus().toggleNote(noteType).run();
		EditorService.setData("lastUsedNoteType", noteType);
	}, [editor, noteType]);

	return (
		<ToolbarDropdownMenuItem active={isActive} disabled={disabled} onClick={onSelectNote}>
			<div className="flex flex-row items-center gap-2 mr-3">
				<StyledIcon icon={noteIcons[noteType]} noteType={noteType} />
				<span>{t(`${noteType}-text`)}</span>
			</div>
		</ToolbarDropdownMenuItem>
	);
};

export default NoteMenuButton;
